import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { BehaviorSubject, Subject, Subscription, firstValueFrom, take } from "rxjs";
import { Router } from "@angular/router";
import { SessionService } from "../../shared/services/Session.service";
import { SignalRService } from "../../shared/services/Signal-R.service";
import { SignalUser } from "../../shared/models/SignalUser/SignalUser";
import { EnumFolderPaths } from "../../shared/helpers/enums/EnumFolderPaths";
import { UrlSasDTO } from "../../shared/models/AzureStorage/UrlSasDTO";
import { SystemNotificationCatalogService } from "../../shared/features/system-notification/services/systemNotificationCatalog.service";
import { AuthService } from "../../authmanagement/services/Auth.service";
import { NotificationService } from "../../notifications/services/Notification.service";
import { TutorialService } from "../../shared/features/tutorial/services/tutorial.service";
import { EncriptionService } from "../../shared/services/Encription.service";
import { AzureStorageService } from "../../shared/services/ServiceCatalogEncapsulators/AzureStorage.service";
import { EnumsService } from "../../shared/services/ServiceCatalogEncapsulators/Enums.service";
import { PermissionsService } from "../../shared/services/ServiceCatalogEncapsulators/Permissions.service";
import { SignalUserService } from "../../shared/services/ServiceCatalogEncapsulators/Signal-User.service";
import { UserConfigurationsService } from "../../shared/services/ServiceCatalogEncapsulators/UserConfigurations.service";
import { ViewsService } from "../../shared/services/ServiceCatalogEncapsulators/Views.service";
import { LocationCategoriesService } from "../../locations-map/services/LocationCategories.service";
import { ImageCacheService } from "../../shared/services/ImageCache.service";
import { LocationsService } from "../../locations-map/services/Locations.service";
import { LocationsMapService } from "../../locations-map/services/Locations-Map.service";
import { CitronellaExternalAPIService } from "../../shared/services/External API/CitronellaExternalAPI.service";
import { CitronellaActionsService } from "../../shared/services/ServiceCatalogEncapsulators/CitronellaActions.service";
import { ThirdPartySettingsService } from "../../shared/services/ServiceCatalogEncapsulators/ThirdPartySettings.service";

@Injectable({
  providedIn: "root",
})
export class SettingsPageService {

  constructor(
  ) {
  }


  setSelectedTab(tab: number) {
    localStorage.setItem('settingsSelectedTab', tab.toString());
  }

  getSelectedTab(): number {
    const tabSelected = localStorage.getItem('settingsSelectedTab');
    const tab = tabSelected != null ? parseInt(tabSelected, 10) : 0;
    return tab;
  }

}
